export const EXCMAGREEMENTSLA_DELETE_RESET = 'EXCMAGREEMENTSLA_DELETE_RESET'
export const EXCMAGREEMENTSLA_DELETE_SET_ERROR = 'EXCMAGREEMENTSLA_DELETE_SET_ERROR'
export const EXCMAGREEMENTSLA_DELETE_SET_DELETED = 'EXCMAGREEMENTSLA_DELETE_SET_DELETED'
export const EXCMAGREEMENTSLA_DELETE_TOGGLE_LOADING = 'EXCMAGREEMENTSLA_DELETE_TOGGLE_LOADING'
